import gql from "graphql-tag";

export default gql`query File($id:Int!) {
    file(id:$id) {
        id    
        reference
        referencelong
        instructiondate
        completiondate
        mortgageofferexpires
        nagdate
        os1date
        bundleCompletionReceived
        swiftMove
        description
        department {
            id
            name
        }
        category {
            id
            name
        }
        box {
            id
        }
        quote {
            id
            cqsnote
            total
            totalClass
        }
        bundleCompletion {
            id
        }
    }
  }`